import { combineLatest, BehaviorSubject } from 'rxjs'
import { map as rxMap } from 'rxjs/operators'
import { map, find } from 'libraries/lodash'
import { updateHistoryState } from 'front-end-core/core/history'
import { RESPONSE_PENDING } from 'front-end-core/constants/responses'
import { mapResponse } from 'front-end-core/helpers/dataflow'
import { LEGISLATION_REFERENCE } from 'constants/requests'
import { fetch } from 'services/ApiService'
import { requestActs } from './LegislationService'

export const $references = new BehaviorSubject({ references: RESPONSE_PENDING })

const validateLinkability = function (references, acts) {
  // checks if references exist in legislation
  return map(references, reference => Object.assign({ linkable: !!find(acts, ['id', reference.context[0].id]) }, reference))
}

export const requestReferences = function (flavour, references, aol) {
  $references.next({ references: RESPONSE_PENDING, flavour })
  updateHistoryState({ pageData: { references } })
  requestReferenceNodes({ references, aol }).pipe(
    rxMap(references => ({ references, flavour }))
  ).subscribe(r => $references.next(r))
}

export const requestReferenceNodes = ({ references, aol }) => combineLatest(
  [fetch(LEGISLATION_REFERENCE, { references, aol }),
    requestActs(aol)],
  mapResponse(validateLinkability)
)
